<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px"
	fxLayoutGap.xs="15px">
	<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div class="descrip-block">
				<app-readability class="app-readability" [height]="(resourceDetail?.description) ? '18' : '0'">
					<content>
						<div class="fx-column fx-start-stretch">
							<ng-container *ngIf="resourceDetail?.description">
								<div class="resource-description">
									{{resourceDetail?.description}}
								</div>
							</ng-container>

							<ng-container *ngIf="resourceDetail?.skills?.length && skillMPermission">
								<div class="skill-pack fx-row-wrap fx-start-start">
									<ng-container *ngFor="let skill of resourceDetail?.skills">
										<app-chips type="progressive" background="var(--secondary-four)"
											[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
										</app-chips>
									</ng-container>
								</div>
							</ng-container>

							<ng-container *ngIf="resourceDetail?.infoFields && (resourceDetail?.infoFields | objectKeys : []).length">
								<div class="fx-row fx-start-start">
									<ng-container *ngIf="resourceDetail?.infoData?.length">
										<ng-container *ngFor="let info of resourceDetail?.infoData">
											<app-common-view [data]="info"></app-common-view>
										</ng-container>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</content>
				</app-readability>
			</div>
		</div>
	</div>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" class="submission-block">
			<div class="submission-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<div class="event-view-block" fxLayout="column" fxLayoutAlign="start stretch">
					<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="22px" fxLayout.xs="column"
						fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="8px">
						<div fxFlex="0 1 398px" fxFlex.xs="auto" class="thumbnail-block">
							<div class="thumbnail cursor-pointer" (click)="embedLink(resourceDetail?.resource?.link)">
								<img [src]="resourceDetail?.resource?.thumbnail | safeDom : 'url'"
									(error)="gfService.setErrorImage($event, 'broken_image')" alt="">
							</div>
						</div>
						<div fxFlex="0 1 414px" fxFlex.xs="1 1" class="event-right-block" fxLayout="column"
							fxLayoutAlign="start stretch" fxLayoutGap="24px" fxLayoutGap.xs="10px">
							<div fxFlex="1 1" class="overview" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="6px">
								<ng-container *ngIf="resourceDetail?.resource?.link">
									<span class="event-link linkable"
										(click)="embedLink(resourceDetail?.resource?.link)">{{resourceDetail?.resource?.link}}</span>
								</ng-container>
							</div>
							<ng-container *ngIf="resourceDetail?.infoFields?.notes">
								<div fxFlex="1 1" class="overview" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="6px">
									<span class="">{{resourceDetail?.infoFields?.notes}}</span>
								</div>
							</ng-container>
							<ng-container *ngIf="resourceDetail?.registrationStatus?.key !== 'noShow'">
								<app-registration-workflow [resourceDetail]="resourceDetail" [popupRef]="popupRef"
									(readLog)="emitReadLog()">
								</app-registration-workflow>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
